import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { TranslateService } from '../translate.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { editToolsIcon } from "@progress/kendo-svg-icons";
import { ServerAPI } from '../../serverapi';

@Component({
  selector: 'translation-editor',
  templateUrl: './translation-editor.component.html',
  styles: `
  .wgrid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 200px;
}`
})
export class TranslationEditorComponent {

  constructor(@Inject('i18n-label') public i18nLabel: any, public translate: TranslateService,
    private _ref: ChangeDetectorRef,@Inject('ServerApi')public apiService: ServerAPI) { 
      this.translate.loadAllStaticRepos();
    }

  public isEdit: boolean = false;

  public icon = editToolsIcon;

  public getKeys() {
    return this.translate.getKeys(this.i18nLabel);
  }

  public async searchOldKopTrans(key: string) {
    await this.translate.searchOldKopTrans(key);
    this._ref.markForCheck();
  }
}
